export enum HRState {
Complete,
Uncomplete,
}
